import { GridRenderEditCellParams, useGridApiContext } from "@mui/x-data-grid";
import * as React from "react";


interface CustomEditComponentProps extends GridRenderEditCellParams {
    le?: number;
    ge?: number;
    l?: number;
    g?: number;
}
function CustomEditNumberComponent(props: CustomEditComponentProps) {
    const { id, field } = props;
    const apiRef = useGridApiContext();

    const handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let newValueStr: string = event.target.value; // The new value entered by the user
        let isNeg = false;
        if (newValueStr.startsWith("-")) {
            isNeg = true;
        }
        newValueStr = newValueStr.split("").filter((c: string) => c === "." || c === "," || (c >= '0' && c <= '9')).join("")
        if (event.target.value === null || event.target.value === undefined || event.target.value == '') {
            apiRef.current.setEditCellValue({ id, field, value: undefined });
            return;
        }

        let newValue = +newValueStr;
        if (isNeg) newValue = -newValue;
        let isGood: boolean = true;

        if (props.le !== undefined && newValue > props.le) isGood = false;
        if (props.ge !== undefined && newValue < props.ge) isGood = false;
        if (props.l !== undefined && newValue >= props.l) isGood = false;
        if (props.g !== undefined && newValue <= props.g) isGood = false;

        if (isGood) {
            apiRef.current.setEditCellValue({ id, field, value: newValue });
        }
    };

    return (
        <input
            type={"number"}
            value={props.value}
            onChange={handleValueChange}
            style={{ "border": "none", "width": "100%", "padding": "0 0 0 10px" }}
            className="no-border-input"
            autoFocus
            onFocus={(event) => event.target.select()}
        />
    );
}


export default CustomEditNumberComponent;
